import PropTypes from 'prop-types';
import React from 'react';
import StyledThinkingSpaceCluster from './thinkingSpaceCluster.style';
import Container from '../../layout/container/container';
import TeaserContainer from '../teaser-container/teaserContainer';
import TypoHeadline from '../../molecules/typo-headline/typoHeadline';

const ThinkingSpaceCluster = ({ headline, headlineId, stations, ...props }) => {
  return (
    <StyledThinkingSpaceCluster {...props}>
      <Container>
        <TypoHeadline headline={headline} headlineId={headlineId} />
      </Container>
      <TeaserContainer data={stations} />
    </StyledThinkingSpaceCluster>
  );
};

ThinkingSpaceCluster.propTypes = {
  headlineId: PropTypes.string,
  headline: PropTypes.string,
  stations: PropTypes.arrayOf(PropTypes.shape())
};

export default ThinkingSpaceCluster;
